/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_Logo_CtaInputs */

const cs_templates_branding_logo_cta = /** @type {(inputs: Templates_Branding_Logo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát logo v Nastavení → Kancelář`)
};

const en_templates_branding_logo_cta = /** @type {(inputs: Templates_Branding_Logo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload logo in Settings → Office`)
};

/**
* | output |
* | --- |
* | "Upload logo in Settings → Office" |
*
* @param {Templates_Branding_Logo_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_logo_cta = /** @type {((inputs?: Templates_Branding_Logo_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_Logo_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_logo_cta(inputs)
	return cs_templates_branding_logo_cta(inputs)
});